import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { Router } from '@angular/router';

let isAlertShown = false;

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  
  private static isAlertShown = false;

  constructor(
    private auth: AuthenticationService,
    private router: Router
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let token = localStorage.getItem('token');
    if (!token) token = 'null';

    // if (token) {
    //   const payload = JSON.parse(atob(token.split('.')[1]));
    //   console.log('Decoded JWT payload:', payload);
    //   console.log('Expires at (exp):', new Date(payload.exp * 1000));
    // }


    request = request.clone({
      setHeaders: {
        authorization: token,
      },
      headers: request.headers.append('authorization', token),
    });

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // if (error.status === 401) {
        //   // 🔔 Show alert on session timeout
        //   alert('⚠️ Your session has expired. Please login again.');

        //   // Optional: Redirect to login page
        //   this.router.navigate(['/login']);
        // }
        if (error.status === 401 && !TokenInterceptor.isAlertShown) {
          TokenInterceptor.isAlertShown = true;
          alert('⚠️ Your session has expired. Please login again.');
          this.router.navigate(['/login']);
          // Reset the flag after a short delay (optional)
          setTimeout(() => TokenInterceptor.isAlertShown = false, 3000);
        }

        return throwError(() => error);
      })
    );
  }
}










// import { Injectable } from '@angular/core';
// import {
//   HttpRequest,
//   HttpHandler,
//   HttpEvent,
//   HttpInterceptor
// } from '@angular/common/http';
// import { Observable } from 'rxjs';
// import { AuthenticationService } from 'src/app/shared/services/authentication.service';

// @Injectable()
// export class TokenInterceptor implements HttpInterceptor {
//   constructor(private auth:AuthenticationService) {}

//   intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
//     let token = localStorage.getItem('token');
//     if(!token)
//       token = 'null';
//     let urlss= request.url;
//     //console.log(token);
//     return next.handle(request = request.clone({
//         setHeaders:{
//           authorization: token,
//         },
//         headers: request.headers.append('authorization', token),
//     }));
//   }
 
// }

